<div class="flex h-full flex-col gap-2">
  <div class="flex flex-row gap-2">
    <p-button (click)="setInProcess(true)" label="In-Process"></p-button>
    <p-button (click)="setInProcess(false)" label="Ship Prep"></p-button>
  </div>

  <div *ngIf="!isInProcess" class="flex flex-row gap-2 mt-4">
    <div class="flex">
      <uni-field label="Scan into Ship Prep...">
        <input
          #scanShipPrep
          style="width: 150px"
          pInputText
          [(ngModel)]="scannedShipPrepDetailId"
          [pAutoFocus]="true"
          name="scannedShipPrepDetailId"
          autocomplete="off"
          maxlength="12"
          size="12"
          (input)="onShipPrepScan($event, scannedShipPrepDetailId)"
        />
      </uni-field>
    </div>
    <div class="mt-8">
      <h6>{{ shipPrepMessage }}</h6>
    </div>
  </div>

  <div *ngIf="!isInProcess" class="flex grow">
    <app-ag-grid
      [hasFooter]="false"
      [gridOptions]="shipPrepGridOptions"
      [rowData]="shipPrepItems"
    ></app-ag-grid>
  </div>

  <div *ngIf="isInProcess" class="flex flex-row gap-2 mt-4">
    <uni-field label="Bin Id" class="w-1/2">
      <input
        pInputText
        placeholder="Scan Bin Id"
        name="binId"
        [(ngModel)]="binId"
        [pAutoFocus]="true"
        #scanBin
      />
    </uni-field>
    <p-button class="mt-5" (click)="getBin()" label="Get Bin"></p-button>
    <p-button class="mt-5" (click)="clearBin()" label="Clear"></p-button>
  </div>

  <div *ngIf="isInProcess">
    <h5>{{ binStatusStr() }}</h5>
  </div>

  <div *ngIf="isInProcess" class="flex flex-row gap-2">
    <div class="flex" *ngIf="okToScan()">
      <uni-field label="Scan to In-Process...">
        <input
          #scanInput
          style="width: 150px"
          pInputText
          [(ngModel)]="scannedItemDetailId"
          name="scannedItemDetailId"
          autocomplete="off"
          maxlength="12"
          size="12"
          (input)="onInputFilled($event, scanItemDetailId)"
        />
      </uni-field>
    </div>

    <div class="mt-8">
      <h6>{{ scanErrorMessage }}</h6>
    </div>
  </div>

  <div *ngIf="isInProcess && okToScan()" class="flex grow">
    <app-ag-grid
      [hasFooter]="false"
      [gridOptions]="detailGridOptions"
      [rowData]="itemDetailAddons"
    ></app-ag-grid>
  </div>
</div>
